export default "__VITE_ASSET__pa5b$LT___"